import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Hero from './components/Hero';
import About from './components/About';
import Diretorias from './components/Diretoria';
import Contato from './components/Contato';
import Cursos from './components/Cursos';
import NotaOficial from './components/NotaOficial';
import Noticias from './components/Noticias';
import RevistaInovaAgro from './components/RevistaInovaAgro';
import Convenios from './components/Convenios';
import AssocieSe from './components/AssocieSe';
import Eventos from './components/Eventos';
import Footer from './components/Footer';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import CookieBanner from './components/CookieBanner';

import NoticiaDetalhe from './components/NoticiaDetalhe';
import EventoDetalhe from './components/EventoDetalhe';
import PoliticaPrivacidade from './components/PoliticaPrivacidade';

import './App.css';

function Home() {
  return (
    <>
      <Hero />
      <About />
      <Diretorias />
      <Cursos />
      <NotaOficial />
      <Noticias />
      <RevistaInovaAgro />
      <Eventos />
      <Contato />
      <Convenios />
      <AssocieSe />
    </>
  );
}

function App() {
  return (
    <div className="App overflow-x-hidden w-full min-h-screen flex flex-col">
      <Header />

      <main className="overflow-x-hidden flex-1 bg-gray-50">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/noticias/:id" element={<NoticiaDetalhe />} />
          <Route path="/eventos/:id" element={<EventoDetalhe />} />
          <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
        </Routes>
      </main>

      <Footer />
      <ScrollToTop />
      <CookieBanner />
    </div>
  );
}

export default App;